import React from 'react'

import { Grid } from '@mui/material'
import AgencyAccounts from 'features/agencies/components/AgencyAccounts'
import AgencyDetails from 'features/agencies/components/AgencyDetails'
import { useAgency } from 'features/agencies/hooks/useAgency'

import LoadingView from 'components/LoadingView'

const CustomerAgency = () => {
  const { data, isLoading } = useAgency()

  const leftSlots = data ? data.total - data.used : 0

  return (
    <LoadingView loading={isLoading}>
      <Grid container spacing={2}>
        <Grid
          size={{
            sm: 5,
          }}>
          <AgencyDetails data={data} />
        </Grid>
        <Grid
          size={{
            sm: 7,
          }}>
          <AgencyAccounts leftSlots={leftSlots} />
        </Grid>
      </Grid>
    </LoadingView>
  )
}

export default CustomerAgency
